@if (visible()) {
  <div class="cookie-backdrop" role="dialog" aria-label="Cookie consent" aria-modal="false">
    <div class="cookie-card">
      <p class="cookie-text">
        We use strictly necessary cookies to operate this site. With your consent, we'd also like to
        set functional, analytics, and marketing cookies to improve your experience. You can accept
        all, reject non-essential, or customize your choices. See our
        <a routerLink="/cookie-policy">cookie policy</a>
        .
      </p>

      @if (customizing()) {
        <fieldset class="cookie-prefs">
          <legend class="sr-only">Cookie preferences</legend>

          <label class="cookie-pref">
            <span class="pref-meta">
              <span class="pref-name">Strictly necessary</span>
              <span class="pref-desc">
                Required for the site to function (session, security, consent record). Always on.
              </span>
            </span>
            <input
              type="checkbox"
              checked
              disabled
              aria-label="Strictly necessary cookies (always on)"
            />
          </label>

          <label class="cookie-pref">
            <span class="pref-meta">
              <span class="pref-name">Functional</span>
              <span class="pref-desc">
                Remember preferences (language, region, UI choices) to personalize your experience.
              </span>
            </span>
            <input
              type="checkbox"
              [checked]="draftFunctional()"
              (change)="toggleFunctional($any($event.target).checked)"
              aria-label="Functional cookies"
            />
          </label>

          <label class="cookie-pref">
            <span class="pref-meta">
              <span class="pref-name">Analytics</span>
              <span class="pref-desc">
                Aggregated usage measurement (Google Analytics) so we can improve the site. IP
                anonymized.
              </span>
            </span>
            <input
              type="checkbox"
              [checked]="draftAnalytics()"
              (change)="toggleAnalytics($any($event.target).checked)"
              aria-label="Analytics cookies"
            />
          </label>

          <label class="cookie-pref">
            <span class="pref-meta">
              <span class="pref-name">Marketing</span>
              <span class="pref-desc">
                Measure campaign effectiveness and show you relevant content off-site.
              </span>
            </span>
            <input
              type="checkbox"
              [checked]="draftMarketing()"
              (change)="toggleMarketing($any($event.target).checked)"
              aria-label="Marketing cookies"
            />
          </label>
        </fieldset>
      }

      <div class="cookie-actions">
        @if (!customizing()) {
          <button type="button" class="btn-accept" (click)="acceptAll()">Accept all</button>
          <button type="button" class="btn-reject" (click)="rejectAll()">Reject all</button>
          <button type="button" class="btn-customize" (click)="openCustomize()">Customize</button>
        } @else {
          <button type="button" class="btn-accept" (click)="savePreferences()">
            Save preferences
          </button>
          <button type="button" class="btn-reject" (click)="rejectAll()">Reject all</button>
        }
      </div>
    </div>
  </div>
}
